export function createStringValidator(validate: (value: string) => string) {
  return ({ value }: { value: string }) => validate(value) || undefined;
}
